import { resolveStyles } from "./auth-service-tools194.js";

function getThemeStyles(_ref) {
  let {
    theme,
    themeName,
    props,
    stylesCtx,
    selector
  } = _ref;
  return themeName.map(n => {
    var _a;

    return resolveStyles({
      theme,
      styles: (_a = theme.components[n]) == null ? void 0 : _a.styles,
      props,
      stylesCtx
    })[selector];
  }).reduce((acc, val) => ({ ...acc,
    ...val
  }), {});
}

export { getThemeStyles };